/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WhatHappensRouteImport } from './routes/what-happens'
import { Route as UniChristianGroupsRouteImport } from './routes/uni-christian-groups'
import { Route as TestimonialsRouteImport } from './routes/testimonials'
import { Route as SessionsRouteImport } from './routes/sessions'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ReconcileRouteImport } from './routes/reconcile'
import { Route as MyRouteImport } from './routes/my'
import { Route as FindUsRouteImport } from './routes/find-us'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as DesignRouteImport } from './routes/design'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CampusTimeRouteImport } from './routes/campus-time'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as ReconcileRefRouteImport } from './routes/reconcile.$ref'
import { Route as PayRefRouteImport } from './routes/pay.$ref'
import { Route as AuthVerifyRouteImport } from './routes/auth.verify'
import { Route as AdminTeamRouteImport } from './routes/admin/team'
import { Route as AdminSubmissionsRouteImport } from './routes/admin/submissions'
import { Route as AdminStudentsRouteImport } from './routes/admin/students'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminRegistrationsRouteImport } from './routes/admin/registrations'
import { Route as AdminReconciliationRouteImport } from './routes/admin/reconciliation'
import { Route as AdminProgramsRouteImport } from './routes/admin/programs'
import { Route as AdminInvoicesRouteImport } from './routes/admin/invoices'
import { Route as AdminFormsRouteImport } from './routes/admin/forms'
import { Route as AdminContentRouteImport } from './routes/admin/content'
import { Route as AdminCheckinRouteImport } from './routes/admin/checkin'
import { Route as AdminAttendanceRouteImport } from './routes/admin/attendance'
import { Route as AdminAssetsRouteImport } from './routes/admin/assets'
import { Route as AdminMessagesIdRouteImport } from './routes/admin/messages.$id'

const WhatHappensRoute = WhatHappensRouteImport.update({
  id: '/what-happens',
  path: '/what-happens',
  getParentRoute: () => rootRouteImport,
} as any)
const UniChristianGroupsRoute = UniChristianGroupsRouteImport.update({
  id: '/uni-christian-groups',
  path: '/uni-christian-groups',
  getParentRoute: () => rootRouteImport,
} as any)
const TestimonialsRoute = TestimonialsRouteImport.update({
  id: '/testimonials',
  path: '/testimonials',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsRoute = SessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const ReconcileRoute = ReconcileRouteImport.update({
  id: '/reconcile',
  path: '/reconcile',
  getParentRoute: () => rootRouteImport,
} as any)
const MyRoute = MyRouteImport.update({
  id: '/my',
  path: '/my',
  getParentRoute: () => rootRouteImport,
} as any)
const FindUsRoute = FindUsRouteImport.update({
  id: '/find-us',
  path: '/find-us',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignRoute = DesignRouteImport.update({
  id: '/design',
  path: '/design',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const CampusTimeRoute = CampusTimeRouteImport.update({
  id: '/campus-time',
  path: '/campus-time',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const ReconcileRefRoute = ReconcileRefRouteImport.update({
  id: '/$ref',
  path: '/$ref',
  getParentRoute: () => ReconcileRoute,
} as any)
const PayRefRoute = PayRefRouteImport.update({
  id: '/pay/$ref',
  path: '/pay/$ref',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyRoute = AuthVerifyRouteImport.update({
  id: '/auth/verify',
  path: '/auth/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTeamRoute = AdminTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSubmissionsRoute = AdminSubmissionsRouteImport.update({
  id: '/submissions',
  path: '/submissions',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStudentsRoute = AdminStudentsRouteImport.update({
  id: '/students',
  path: '/students',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRegistrationsRoute = AdminRegistrationsRouteImport.update({
  id: '/registrations',
  path: '/registrations',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReconciliationRoute = AdminReconciliationRouteImport.update({
  id: '/reconciliation',
  path: '/reconciliation',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProgramsRoute = AdminProgramsRouteImport.update({
  id: '/programs',
  path: '/programs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInvoicesRoute = AdminInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFormsRoute = AdminFormsRouteImport.update({
  id: '/forms',
  path: '/forms',
  getParentRoute: () => AdminRoute,
} as any)
const AdminContentRoute = AdminContentRouteImport.update({
  id: '/content',
  path: '/content',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCheckinRoute = AdminCheckinRouteImport.update({
  id: '/checkin',
  path: '/checkin',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAttendanceRoute = AdminAttendanceRouteImport.update({
  id: '/attendance',
  path: '/attendance',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAssetsRoute = AdminAssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMessagesIdRoute = AdminMessagesIdRouteImport.update({
  id: '/messages/$id',
  path: '/messages/$id',
  getParentRoute: () => AdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/campus-time': typeof CampusTimeRoute
  '/contact': typeof ContactRoute
  '/design': typeof DesignRoute
  '/faq': typeof FaqRoute
  '/find-us': typeof FindUsRoute
  '/my': typeof MyRoute
  '/reconcile': typeof ReconcileRouteWithChildren
  '/register': typeof RegisterRoute
  '/sessions': typeof SessionsRoute
  '/testimonials': typeof TestimonialsRoute
  '/uni-christian-groups': typeof UniChristianGroupsRoute
  '/what-happens': typeof WhatHappensRoute
  '/admin/assets': typeof AdminAssetsRoute
  '/admin/attendance': typeof AdminAttendanceRoute
  '/admin/checkin': typeof AdminCheckinRoute
  '/admin/content': typeof AdminContentRoute
  '/admin/forms': typeof AdminFormsRoute
  '/admin/invoices': typeof AdminInvoicesRoute
  '/admin/programs': typeof AdminProgramsRoute
  '/admin/reconciliation': typeof AdminReconciliationRoute
  '/admin/registrations': typeof AdminRegistrationsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/students': typeof AdminStudentsRoute
  '/admin/submissions': typeof AdminSubmissionsRoute
  '/admin/team': typeof AdminTeamRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/pay/$ref': typeof PayRefRoute
  '/reconcile/$ref': typeof ReconcileRefRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/messages/$id': typeof AdminMessagesIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/campus-time': typeof CampusTimeRoute
  '/contact': typeof ContactRoute
  '/design': typeof DesignRoute
  '/faq': typeof FaqRoute
  '/find-us': typeof FindUsRoute
  '/my': typeof MyRoute
  '/reconcile': typeof ReconcileRouteWithChildren
  '/register': typeof RegisterRoute
  '/sessions': typeof SessionsRoute
  '/testimonials': typeof TestimonialsRoute
  '/uni-christian-groups': typeof UniChristianGroupsRoute
  '/what-happens': typeof WhatHappensRoute
  '/admin/assets': typeof AdminAssetsRoute
  '/admin/attendance': typeof AdminAttendanceRoute
  '/admin/checkin': typeof AdminCheckinRoute
  '/admin/content': typeof AdminContentRoute
  '/admin/forms': typeof AdminFormsRoute
  '/admin/invoices': typeof AdminInvoicesRoute
  '/admin/programs': typeof AdminProgramsRoute
  '/admin/reconciliation': typeof AdminReconciliationRoute
  '/admin/registrations': typeof AdminRegistrationsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/students': typeof AdminStudentsRoute
  '/admin/submissions': typeof AdminSubmissionsRoute
  '/admin/team': typeof AdminTeamRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/pay/$ref': typeof PayRefRoute
  '/reconcile/$ref': typeof ReconcileRefRoute
  '/admin': typeof AdminIndexRoute
  '/admin/messages/$id': typeof AdminMessagesIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/campus-time': typeof CampusTimeRoute
  '/contact': typeof ContactRoute
  '/design': typeof DesignRoute
  '/faq': typeof FaqRoute
  '/find-us': typeof FindUsRoute
  '/my': typeof MyRoute
  '/reconcile': typeof ReconcileRouteWithChildren
  '/register': typeof RegisterRoute
  '/sessions': typeof SessionsRoute
  '/testimonials': typeof TestimonialsRoute
  '/uni-christian-groups': typeof UniChristianGroupsRoute
  '/what-happens': typeof WhatHappensRoute
  '/admin/assets': typeof AdminAssetsRoute
  '/admin/attendance': typeof AdminAttendanceRoute
  '/admin/checkin': typeof AdminCheckinRoute
  '/admin/content': typeof AdminContentRoute
  '/admin/forms': typeof AdminFormsRoute
  '/admin/invoices': typeof AdminInvoicesRoute
  '/admin/programs': typeof AdminProgramsRoute
  '/admin/reconciliation': typeof AdminReconciliationRoute
  '/admin/registrations': typeof AdminRegistrationsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/students': typeof AdminStudentsRoute
  '/admin/submissions': typeof AdminSubmissionsRoute
  '/admin/team': typeof AdminTeamRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/pay/$ref': typeof PayRefRoute
  '/reconcile/$ref': typeof ReconcileRefRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/messages/$id': typeof AdminMessagesIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/campus-time'
    | '/contact'
    | '/design'
    | '/faq'
    | '/find-us'
    | '/my'
    | '/reconcile'
    | '/register'
    | '/sessions'
    | '/testimonials'
    | '/uni-christian-groups'
    | '/what-happens'
    | '/admin/assets'
    | '/admin/attendance'
    | '/admin/checkin'
    | '/admin/content'
    | '/admin/forms'
    | '/admin/invoices'
    | '/admin/programs'
    | '/admin/reconciliation'
    | '/admin/registrations'
    | '/admin/settings'
    | '/admin/students'
    | '/admin/submissions'
    | '/admin/team'
    | '/auth/verify'
    | '/pay/$ref'
    | '/reconcile/$ref'
    | '/admin/'
    | '/admin/messages/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/campus-time'
    | '/contact'
    | '/design'
    | '/faq'
    | '/find-us'
    | '/my'
    | '/reconcile'
    | '/register'
    | '/sessions'
    | '/testimonials'
    | '/uni-christian-groups'
    | '/what-happens'
    | '/admin/assets'
    | '/admin/attendance'
    | '/admin/checkin'
    | '/admin/content'
    | '/admin/forms'
    | '/admin/invoices'
    | '/admin/programs'
    | '/admin/reconciliation'
    | '/admin/registrations'
    | '/admin/settings'
    | '/admin/students'
    | '/admin/submissions'
    | '/admin/team'
    | '/auth/verify'
    | '/pay/$ref'
    | '/reconcile/$ref'
    | '/admin'
    | '/admin/messages/$id'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/campus-time'
    | '/contact'
    | '/design'
    | '/faq'
    | '/find-us'
    | '/my'
    | '/reconcile'
    | '/register'
    | '/sessions'
    | '/testimonials'
    | '/uni-christian-groups'
    | '/what-happens'
    | '/admin/assets'
    | '/admin/attendance'
    | '/admin/checkin'
    | '/admin/content'
    | '/admin/forms'
    | '/admin/invoices'
    | '/admin/programs'
    | '/admin/reconciliation'
    | '/admin/registrations'
    | '/admin/settings'
    | '/admin/students'
    | '/admin/submissions'
    | '/admin/team'
    | '/auth/verify'
    | '/pay/$ref'
    | '/reconcile/$ref'
    | '/admin/'
    | '/admin/messages/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  CampusTimeRoute: typeof CampusTimeRoute
  ContactRoute: typeof ContactRoute
  DesignRoute: typeof DesignRoute
  FaqRoute: typeof FaqRoute
  FindUsRoute: typeof FindUsRoute
  MyRoute: typeof MyRoute
  ReconcileRoute: typeof ReconcileRouteWithChildren
  RegisterRoute: typeof RegisterRoute
  SessionsRoute: typeof SessionsRoute
  TestimonialsRoute: typeof TestimonialsRoute
  UniChristianGroupsRoute: typeof UniChristianGroupsRoute
  WhatHappensRoute: typeof WhatHappensRoute
  AuthVerifyRoute: typeof AuthVerifyRoute
  PayRefRoute: typeof PayRefRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/what-happens': {
      id: '/what-happens'
      path: '/what-happens'
      fullPath: '/what-happens'
      preLoaderRoute: typeof WhatHappensRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/uni-christian-groups': {
      id: '/uni-christian-groups'
      path: '/uni-christian-groups'
      fullPath: '/uni-christian-groups'
      preLoaderRoute: typeof UniChristianGroupsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/testimonials': {
      id: '/testimonials'
      path: '/testimonials'
      fullPath: '/testimonials'
      preLoaderRoute: typeof TestimonialsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions': {
      id: '/sessions'
      path: '/sessions'
      fullPath: '/sessions'
      preLoaderRoute: typeof SessionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reconcile': {
      id: '/reconcile'
      path: '/reconcile'
      fullPath: '/reconcile'
      preLoaderRoute: typeof ReconcileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my': {
      id: '/my'
      path: '/my'
      fullPath: '/my'
      preLoaderRoute: typeof MyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/find-us': {
      id: '/find-us'
      path: '/find-us'
      fullPath: '/find-us'
      preLoaderRoute: typeof FindUsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design': {
      id: '/design'
      path: '/design'
      fullPath: '/design'
      preLoaderRoute: typeof DesignRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campus-time': {
      id: '/campus-time'
      path: '/campus-time'
      fullPath: '/campus-time'
      preLoaderRoute: typeof CampusTimeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/reconcile/$ref': {
      id: '/reconcile/$ref'
      path: '/$ref'
      fullPath: '/reconcile/$ref'
      preLoaderRoute: typeof ReconcileRefRouteImport
      parentRoute: typeof ReconcileRoute
    }
    '/pay/$ref': {
      id: '/pay/$ref'
      path: '/pay/$ref'
      fullPath: '/pay/$ref'
      preLoaderRoute: typeof PayRefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/verify': {
      id: '/auth/verify'
      path: '/auth/verify'
      fullPath: '/auth/verify'
      preLoaderRoute: typeof AuthVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/team': {
      id: '/admin/team'
      path: '/team'
      fullPath: '/admin/team'
      preLoaderRoute: typeof AdminTeamRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/submissions': {
      id: '/admin/submissions'
      path: '/submissions'
      fullPath: '/admin/submissions'
      preLoaderRoute: typeof AdminSubmissionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/students': {
      id: '/admin/students'
      path: '/students'
      fullPath: '/admin/students'
      preLoaderRoute: typeof AdminStudentsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/registrations': {
      id: '/admin/registrations'
      path: '/registrations'
      fullPath: '/admin/registrations'
      preLoaderRoute: typeof AdminRegistrationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/reconciliation': {
      id: '/admin/reconciliation'
      path: '/reconciliation'
      fullPath: '/admin/reconciliation'
      preLoaderRoute: typeof AdminReconciliationRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/programs': {
      id: '/admin/programs'
      path: '/programs'
      fullPath: '/admin/programs'
      preLoaderRoute: typeof AdminProgramsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/invoices': {
      id: '/admin/invoices'
      path: '/invoices'
      fullPath: '/admin/invoices'
      preLoaderRoute: typeof AdminInvoicesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/forms': {
      id: '/admin/forms'
      path: '/forms'
      fullPath: '/admin/forms'
      preLoaderRoute: typeof AdminFormsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/content': {
      id: '/admin/content'
      path: '/content'
      fullPath: '/admin/content'
      preLoaderRoute: typeof AdminContentRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/checkin': {
      id: '/admin/checkin'
      path: '/checkin'
      fullPath: '/admin/checkin'
      preLoaderRoute: typeof AdminCheckinRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/attendance': {
      id: '/admin/attendance'
      path: '/attendance'
      fullPath: '/admin/attendance'
      preLoaderRoute: typeof AdminAttendanceRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/assets': {
      id: '/admin/assets'
      path: '/assets'
      fullPath: '/admin/assets'
      preLoaderRoute: typeof AdminAssetsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/messages/$id': {
      id: '/admin/messages/$id'
      path: '/messages/$id'
      fullPath: '/admin/messages/$id'
      preLoaderRoute: typeof AdminMessagesIdRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminRouteChildren {
  AdminAssetsRoute: typeof AdminAssetsRoute
  AdminAttendanceRoute: typeof AdminAttendanceRoute
  AdminCheckinRoute: typeof AdminCheckinRoute
  AdminContentRoute: typeof AdminContentRoute
  AdminFormsRoute: typeof AdminFormsRoute
  AdminInvoicesRoute: typeof AdminInvoicesRoute
  AdminProgramsRoute: typeof AdminProgramsRoute
  AdminReconciliationRoute: typeof AdminReconciliationRoute
  AdminRegistrationsRoute: typeof AdminRegistrationsRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminStudentsRoute: typeof AdminStudentsRoute
  AdminSubmissionsRoute: typeof AdminSubmissionsRoute
  AdminTeamRoute: typeof AdminTeamRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminMessagesIdRoute: typeof AdminMessagesIdRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAssetsRoute: AdminAssetsRoute,
  AdminAttendanceRoute: AdminAttendanceRoute,
  AdminCheckinRoute: AdminCheckinRoute,
  AdminContentRoute: AdminContentRoute,
  AdminFormsRoute: AdminFormsRoute,
  AdminInvoicesRoute: AdminInvoicesRoute,
  AdminProgramsRoute: AdminProgramsRoute,
  AdminReconciliationRoute: AdminReconciliationRoute,
  AdminRegistrationsRoute: AdminRegistrationsRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminStudentsRoute: AdminStudentsRoute,
  AdminSubmissionsRoute: AdminSubmissionsRoute,
  AdminTeamRoute: AdminTeamRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminMessagesIdRoute: AdminMessagesIdRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface ReconcileRouteChildren {
  ReconcileRefRoute: typeof ReconcileRefRoute
}

const ReconcileRouteChildren: ReconcileRouteChildren = {
  ReconcileRefRoute: ReconcileRefRoute,
}

const ReconcileRouteWithChildren = ReconcileRoute._addFileChildren(
  ReconcileRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  CampusTimeRoute: CampusTimeRoute,
  ContactRoute: ContactRoute,
  DesignRoute: DesignRoute,
  FaqRoute: FaqRoute,
  FindUsRoute: FindUsRoute,
  MyRoute: MyRoute,
  ReconcileRoute: ReconcileRouteWithChildren,
  RegisterRoute: RegisterRoute,
  SessionsRoute: SessionsRoute,
  TestimonialsRoute: TestimonialsRoute,
  UniChristianGroupsRoute: UniChristianGroupsRoute,
  WhatHappensRoute: WhatHappensRoute,
  AuthVerifyRoute: AuthVerifyRoute,
  PayRefRoute: PayRefRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
